<template>
  <v-navigation-drawer v-model="drawer" permanent app fixed class="pt-5 left-sidebar v-navigation-drawer v-navigation-drawer--fixed v-navigation-drawer--open theme--light" color="lighten-4" style="overflow-y: auto;" mini-variant>
    <v-img :src="require('@/assets/logo_left_sidebar.svg')" class="d-block text-center mx-auto mb-9" alt="logo" width="58"
      contain></v-img>
      <v-layout justify-space-between column fill-height>
    <v-list dense>
      <v-list-item-group v-model="group">
        <v-list-item>
          <v-list-item-title>
            <router-link :to="{ name: 'Main' }" class="menu">
              <div class="menu-logo">
                <img src="/playground_assets/mediumhomei324-vuo.svg" alt="">
              </div>
              <div class="menu-title">
                Ресепшен
              </div>
            </router-link>
          </v-list-item-title>
        </v-list-item>

        <v-list-item>
          <v-list-item-title>
            <router-link :to="{name: 'Clients'}" class="menu">
              <div class="menu-logo">
                <img src="/playground_assets/mediumusersi324-9lwk.svg" alt="">
              </div>
              <div class="menu-title">
                Клиенты
              </div>
            </router-link>
          </v-list-item-title>
        </v-list-item>

        <v-list-item>
          <v-list-item-title>
            <router-link :to="{ name: 'Schedule' }" class="menu">
              <div class="menu-logo">
                <img src="/playground_assets/mediumcalendari324-rc.svg" alt="">
              </div>
              <div class="menu-title">
                Расписание
              </div>
            </router-link>
          </v-list-item-title>
        </v-list-item>

        <v-list-item>
          <v-list-item-title>
            <router-link :to="{ name: 'Cashbox' }" class="menu">
              <div class="menu-logo">
                <img src="/playground_assets/mediumrubi324-ows.svg" alt="">
              </div>
              <div class="menu-title">
                Касса
              </div>
            </router-link>
          </v-list-item-title>
        </v-list-item>

        <v-list-item>
          <v-list-item-title>
            <router-link to="/reports" class="menu">
              <div class="menu-logo">
                <img src="/playground_assets/mediumarchivei324-tcep.svg" alt="">
              </div>
              <div class="menu-title">
                Отчеты
              </div>
            </router-link>
          </v-list-item-title>
        </v-list-item>

        <v-list-item>
          <v-list-item-title>
            <router-link :to="{ name: 'SalesMonitor' }" class="menu">
              <div class="menu-logo">
                <Icon iconName="money" width="20" height="21" viewBox="0 0 20 21" strockeWidth="0.1" />
              </div>
              <div class="menu-title">
                Продажи
              </div>
            </router-link>
          </v-list-item-title>
        </v-list-item>

        <v-list-item>
          <v-list-item-title>
            <router-link :to="{ name: 'Extension' }" class="menu">
              <div class="menu-logo">
                <Icon iconName="extension" width="20" height="20" viewBox="0 0 20 20" strockeWidth="2" />
              </div>
              <div class="menu-title">
                Продления
              </div>
            </router-link>
          </v-list-item-title>
        </v-list-item>

        <v-list-item>
          <v-list-item-title>
            <router-link :to="{ name: 'ReportsSalesDepartment' }" class="menu">
              <div class="menu-logo">
                <img src="/playground_assets/mediumarchivei324-tcep.svg" alt="">
              </div>
              <div class="menu-title">
                Отчеты (отдел продаж)
              </div>
            </router-link>
          </v-list-item-title>
        </v-list-item>

        <v-list-item>
          <v-list-item-title>
            <router-link :to="{ name: 'AdminMain' }" class="menu">
              <div class="menu-logo">
                <img src="/playground_assets/mediumhomei324-vuo.svg" alt="">
              </div>
              <div class="menu-title">
                Рабочий стол (админ)
              </div>
            </router-link>
          </v-list-item-title>
        </v-list-item>

        <v-list-item>
          <v-list-item-title>
            <router-link :to="{name: 'AdminStaff'}" class="menu">
              <div class="menu-logo">
                <img src="/playground_assets/mediumusersi324-9lwk.svg" alt="">
              </div>
              <div class="menu-title">
                Персонал (админ)
              </div>
            </router-link>
          </v-list-item-title>
        </v-list-item>

        <v-list-item>
          <v-list-item-title>
            <router-link :to="{ name: 'AdminNormatives' }" class="menu">
              <div class="menu-logo">
                <img src="/playground_assets/mediumcalendari324-rc.svg" alt="">
              </div>
              <div class="menu-title">
                Нормативы (админ)
              </div>
            </router-link>
          </v-list-item-title>
        </v-list-item>

        <v-list-item>
          <v-list-item-title>
            <router-link :to="{ name: 'AdminLessons' }" class="menu">
              <div class="menu-logo">
                <img src="/playground_assets/mediumrubi324-ows.svg" alt="">
              </div>
              <div class="menu-title">
                Занятия (админ)
              </div>
            </router-link>
          </v-list-item-title>
        </v-list-item>



        <v-list-item>
          <v-list-item-title>
            <router-link :to="{ name: 'ReportsAdminDepartment' }" class="menu">
              <div class="menu-logo">
                <img src="/playground_assets/mediumarchivei324-tcep.svg" alt="">
              </div>
              <div class="menu-title">
                Отчеты (админ)
              </div>
            </router-link>
          </v-list-item-title>
        </v-list-item>

      </v-list-item-group>
    </v-list>
  </v-layout>
  </v-navigation-drawer>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "AdminMenu",
  computed: {
    ...mapState({
      userType: state => state.userType, //Роль пользователя
    }),
  },
  data() {
    return {
      drawer: true,
      group: null,
    }
  }
}
</script>

<style scoped>
.menu {
  height: 80px;
  padding: 8px 25px;
  display: flex;
  justify-content: center;
  text-decoration: none;
  flex-direction: column;
    align-items: center;
}

.router-link-active {
  background: #F1F1F1 !important;
  border-right: 4px solid #629F33;
  border-left: 4px solid transparent;
}

.router-link-active>.menu-logo {
  background: #629F33 !important;
}

.router-link-active>.menu-title {
  color: #629F33 !important;
}

.router-link-active:hover {
  background: #F1F1F1 !important;
}

.router-link-active:hover>.menu-logo {
  background: #629F33 !important;
}

.router-link-active:hover>.menu-title {
  color: #629F33 !important;
}

.v-list-item:hover {
  background: none !important;
}

.menu:hover {
  background: #F1F1F1;
}

.menu:hover>.menu-logo {
  background: #000;
}

.menu:hover>.menu-title {
  color: #000;
}

.v-list-item {
  padding: 0 0 8px !important;
}

.v-list-item:before {
  background: none !important;
}

.menu-logo {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #767676;
  border-radius: 25px;
  color: #fff;
}

.menu-title {
  padding-top: 8px;
  text-decoration: none;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #767676;
}
.v-navigation-drawer__content{
overflow: inherit!important;
}
.v-navigation-drawer::-webkit-scrollbar {
    width: 4px !important;
}
html {
  scrollbar-width: thin;
}
</style>